import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import AddUpdateSubjectCard from "../Card/AddUpdateSubjectCard";



function AddUpdateSubjectDialog({ onClose, open, afterUpdateFunc, selectedSubject, addAfterTable }) {

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
            <DialogTitle>{selectedSubject ? 'Konu Güncelle' : 'Konu Ekle'}</DialogTitle>
            <DialogContent dividers>
                <AddUpdateSubjectCard afterUpdateFunc={afterUpdateFunc} selectedSubject={selectedSubject} onClose={onClose} addAfterTable={addAfterTable} />
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

export default AddUpdateSubjectDialog